'use client';

import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { AdvancedMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import type { Dispatch, SetStateAction } from 'react';
import { calculateAdvancedMentoringPrice } from '../../prices';
import { useUpdateMentoringProductOnTabChange } from '../AdvancedMentoring/_hooks/updateMentoringProductOnTabChange';
import { MentorReplyTime } from '../AdvancedMentoring/_sections/MentorReplyTime';
import { ApplicationHelp } from './_sections/ApplicationHelp';
import { CareerCoaching } from './_sections/CareerCoaching';
import { CodeInspection } from './_sections/CodeInspection';
import { HoursWithMentor } from './_sections/HoursWithMentor';
type AdvancedMentoringManagerProps = {
  activeSubscriptionTab: Subscription;
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  setAdvancedMentoringProduct: Dispatch<SetStateAction<AdvancedMentoringProductDTO>>;
};
export function AdvancedMentoringManager(t0) {
  const $ = _c(10);
  const {
    activeSubscriptionTab,
    advancedMentoringProduct,
    setAdvancedMentoringProduct
  } = t0;
  let t1;
  if ($[0] !== activeSubscriptionTab || $[1] !== advancedMentoringProduct || $[2] !== setAdvancedMentoringProduct) {
    t1 = {
      mentoringProduct: advancedMentoringProduct,
      subscription: activeSubscriptionTab,
      setMentoringProduct: setAdvancedMentoringProduct
    };
    $[0] = activeSubscriptionTab;
    $[1] = advancedMentoringProduct;
    $[2] = setAdvancedMentoringProduct;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useUpdateMentoringProductOnTabChange(t1);
  let t2;
  if ($[4] !== setAdvancedMentoringProduct) {
    t2 = updates => {
      setAdvancedMentoringProduct(prev => {
        const newUpdates = typeof updates === "function" ? updates(prev) : updates;
        const updatedProduct = {
          ...prev,
          ...newUpdates
        };
        const calculatedPrice = calculateAdvancedMentoringPrice({
          hoursWithMentor: updatedProduct.hoursWithMentor,
          mentorReplyTime: updatedProduct.mentorReplyTime,
          linesOfCode: updatedProduct.linesOfCode,
          applicationHelp: updatedProduct.applicationHelp,
          careerCoaching: updatedProduct.careerCoaching
        });
        return {
          ...updatedProduct,
          price: calculatedPrice
        };
      });
    };
    $[4] = setAdvancedMentoringProduct;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const updateProduct = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [HoursWithMentor, MentorReplyTime, CodeInspection, ApplicationHelp, CareerCoaching];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== advancedMentoringProduct || $[8] !== updateProduct) {
    t4 = <div className="space-y-8">{t3.map((Component, index) => <Component key={index} advancedMentoringProduct={advancedMentoringProduct} updateProduct={updateProduct} />)}</div>;
    $[7] = advancedMentoringProduct;
    $[8] = updateProduct;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}